import React from 'react';
import SEO, { seoConfigs } from '../../common/SEO/SEO';

const TermsPage = () => (
    <>
    <SEO {...seoConfigs.terms} />
    <div className="bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl p-8">
            <h1 className="text-3xl font-bold text-blue-600 mb-6">Términos y Condiciones</h1>
            <p className="mb-4 text-gray-700">
                Bienvenido a MisTramites.mx. Por favor, lee cuidadosamente los siguientes términos y condiciones antes de utilizar nuestro sitio web y servicios.
            </p>
            <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">1. Aceptación de los Términos</h2>
            <p className="mb-4 text-gray-700">
                Al acceder y utilizar este sitio, aceptas cumplir con estos términos y condiciones. Si no estás de acuerdo, por favor no utilices el sitio.
            </p>
            <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">2. Uso del Servicio</h2>
            <p className="mb-4 text-gray-700">
                El usuario se compromete a utilizar el sitio y los servicios de manera lícita y responsable. No se permite el uso indebido, fraudulento o que afecte a terceros.
            </p>
            <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">3. Privacidad</h2>
            <p className="mb-4 text-gray-700">
                Consulta nuestro Aviso de Privacidad para conocer cómo protegemos y utilizamos tu información personal.
            </p>
            <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">4. Modificaciones</h2>
            <p className="mb-4 text-gray-700">
                Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones serán publicadas en esta página.
            </p>
            <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">5. Contacto</h2>
            <p className="mb-4 text-gray-700">
                Para cualquier duda sobre estos términos, contáctanos en contacto@mistramites.mx.
            </p>
            <div className="mt-8 text-xs text-gray-400">
                &copy; {new Date().getFullYear()} MisTramites.mx. Todos los derechos reservados.
            </div>
        </div>
    </div>
    </>
);

export default TermsPage;
